/*
 ** This name pattern follows the SHIELD name validation.
 ** E.g What SHIELD accepts (not the standard that everybody knows).
 ** If extracting to Design System, this will need to be removed
 */
export const NameValidationPattern = /(?!\s)^[a-zA-Z\s'\-—’()]*$/;
export const LastNameSizeLimit = 50;
